import React, { useEffect, useState, useContext } from "react";
import { Container, Row, Col, Form, Spinner, Alert, Modal, Button } from "react-bootstrap";
import DocumentTable from "../components/DocumentTable";
import orderService from "../services/orderService";
import { ThemeContext } from "../context/ThemeContext";

function Documents() {
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const [filterData, setFilterData] = useState("");
  const [filterDoc, setFilterDoc] = useState("");
  const [showEvasi, setShowEvasi] = useState(false);

  // Stato per anteprima
  const [loadingPreview, setLoadingPreview] = useState(false);
  const [showPreview, setShowPreview] = useState(false);
  const [urlAnteprima, setUrlAnteprima] = useState("");

  const { darkMode } = useContext(ThemeContext);

  const loadDocuments = async (evaso = false) => {
    try {
      setLoading(true);
      const data = await orderService.getDDT(evaso);
      setDocuments(data || []);
      setError(null);
    } catch (err) {
      setError(`Errore nel caricamento dei documenti: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

  // Funzione handlePreview spostata qui
  const handlePreview = async (tblocco) => {
    // setShowPreview(true);         // RIMOSSO: Apertura diretta in nuova tab
    setLoadingPreview(true);
    // setUrlAnteprima(""); // RIMOSSO
    
    try {
      // La funzione creaAnteprima ora apre direttamente la nuova finestra
      await orderService.creaAnteprima(tblocco, showEvasi);
      
    } catch (error) {
      console.error("Errore nell'apertura dell'anteprima:", error);
      setLoadingPreview(false);
      alert("Errore nell'apertura del documento");
      // setShowPreview(false);
    } finally {
      setLoadingPreview(false);
    }
  };


  useEffect(() => {
    loadDocuments(showEvasi);
  }, [showEvasi]);

  const handleToggleEvasi = () => {
    setShowEvasi(!showEvasi);
  };

  const filteredDocs = documents.filter((doc) => {
    // Debug per vedere il formato delle date
    if (documents.length > 0 && !window.debugDateFormat) {
      console.log("Formato data doc.data_cons:", doc.data_cons);
      console.log("Formato filterData:", filterData);
      window.debugDateFormat = true; // Evita log ripetuti
    }
    
    const matchData = filterData ? (() => {
      if (!doc.data_cons) return false;
      
      // Prova diversi formati di confronto
      const docDate = doc.data_cons.toString();
      const filterDate = filterData;
      
      // Confronto diretto
      if (docDate === filterDate) return true;
      
      // Se filterData è in formato YYYY-MM-DD, confronta con vari formati
      if (filterDate.includes('-')) {
        const [year, month, day] = filterDate.split('-');
        
        // Formato YYYY-MM-DD
        if (docDate === `${year}-${month}-${day}`) return true;
        
        // Formato DD/MM/YYYY
        if (docDate === `${day}/${month}/${year}`) return true;
        
        // Formato DD-MM-YYYY
        if (docDate === `${day}-${month}-${year}`) return true;
        
        // Formato DDMMYYYY
        if (docDate === `${day}${month}${year}`) return true;
        
        // Confronto con startsWith per date parziali
        if (docDate.startsWith(filterDate)) return true;
        if (docDate.startsWith(`${year}-${month}-${day}`)) return true;
        if (docDate.startsWith(`${day}/${month}/${year}`)) return true;
      }
      
      return false;
    })() : true;
    
    const matchDoc = filterDoc ? doc.n_bolla?.toString().includes(filterDoc) : true;
    return matchData && matchDoc;
  });

  return (
    <Container fluid className={`py-3 ${darkMode ? "text-light" : ""}`}>

      <div
        className="sticky-top pt-2"
        style={{ zIndex: 1020, top: '60px', background: darkMode ? '#121212' : '#FFFEF9' }}
      >
        <h3>Documenti Cliente</h3>
        <Row className="g-2 mb-3">
          <Col md={3}>
            <Form.Control
              type="date"
              value={filterData}
              onChange={(e) => setFilterData(e.target.value)}
            />
          </Col>
          <Col md={3}>
            <Form.Control
              type="text"
              placeholder="Filtra per N DDT"
              value={filterDoc}
              onChange={(e) => setFilterDoc(e.target.value)}
            />
          </Col>
          <Col md={3} className="d-flex align-items-center">
            <Form.Check
              type="switch"
              id="toggle-evasi"
              label={showEvasi ? "Documenti Evasi" : "Documenti in Essere"}
              checked={showEvasi}
              onChange={handleToggleEvasi}
              className={darkMode ? "text-light" : ""}
            />
          </Col>
        </Row>

        {/* Dissolvenza gradiente: la lista sottostante sfuma scorrendo sotto la barra dei filtri */}
        <div
          aria-hidden="true"
          style={{
            position: 'absolute',
            left: 0,
            right: 0,
            bottom: 0,
            transform: 'translateY(100%)',
            height: 26,
            pointerEvents: 'none',
            background: `linear-gradient(to bottom, ${darkMode ? '#121212' : '#FFFEF9'} 0%, ${darkMode ? 'rgba(18,18,18,0)' : 'rgba(255,254,249,0)'} 100%)`,
          }}
        />
      </div>

      {loading ? (
        <Spinner animation="border" />
      ) : error ? (
        <Alert variant="danger">{error}</Alert>
      ) : (
        <DocumentTable documents={filteredDocs} onPreview={handlePreview} />
      )}

      {/* Modale anteprima */}
      <Modal
        show={showPreview}
        onHide={() => {
          setShowPreview(false);
          setUrlAnteprima("");
          setLoadingPreview(false);
        }}
        fullscreen
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Anteprima Documento</Modal.Title>
          {urlAnteprima && (
            <Button 
              variant="outline-primary" 
              size="sm"
              onClick={() => window.open(urlAnteprima, '_blank')}
              className="ms-auto me-2"
            >
              <i className="fas fa-external-link-alt me-1"></i>
              Apri in nuova finestra
            </Button>
          )}
        </Modal.Header>
        <Modal.Body className="p-0" style={{ height: "90vh" }}>
          {/* Overlay di caricamento */}
          {loadingPreview && (
            <div
              style={{
                position: "absolute",
                top: 0, left: 0, width: "100%", height: "100%",
                background: "rgba(255,255,255,0.5)",
                zIndex: 10,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "wait"
              }}
            >
              <Spinner animation="border" variant="primary" />
            </div>
          )}
          {/* Iframe anteprima */}
          {urlAnteprima && (
            <iframe
              src={urlAnteprima}
              title="Anteprima"
              style={{ width: "100%", height: "100%", border: "none" }}
              onLoad={() => {
                console.log("Iframe caricato con successo");
                setLoadingPreview(false);
              }}
              onError={(e) => {
                console.error("Errore nel caricamento iframe:", e);
                setLoadingPreview(false);
                alert("Errore nel caricamento del documento. Prova ad aprirlo in una nuova finestra.");
              }}
              sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
            />
          )}
          
          {/* Messaggio di errore se l'iframe non si carica */}
          {!loadingPreview && !urlAnteprima && showPreview && (
            <div className="d-flex flex-column align-items-center justify-content-center h-100">
              <Alert variant="warning" className="text-center">
                <h5>Documento non disponibile</h5>
                <p>Il documento potrebbe non essere pronto. Riprova tra qualche secondo.</p>
                <Button 
                  variant="primary" 
                  onClick={() => window.open(urlAnteprima, '_blank')}
                  disabled={!urlAnteprima}
                >
                  Apri in nuova finestra
                </Button>
              </Alert>
            </div>
          )}
        </Modal.Body>
      </Modal>

    </Container>
  );
}

export default Documents;
